import React from "react";
import { Link } from "react-router-dom";
import styles from "../SubjectSinglePage.module.css";
import type { SubjectItem } from "../model/types";

type SubjectWorkspaceBreadcrumbProps = {
  selectedPath: SubjectItem[];
  onResetSubjects: () => void;
  onChooseSubject: (subjectId: number) => void;
};

export const SubjectWorkspaceBreadcrumb: React.FC<
  SubjectWorkspaceBreadcrumbProps
> = ({ selectedPath, onResetSubjects, onChooseSubject }) => (
  <nav className={styles.breadcrumb} aria-label="Breadcrumb">
    <Link to="/">Subject Tree</Link>
    <span>›</span>
    <button type="button" onClick={onResetSubjects}>
      Subjects
    </button>
    {selectedPath.map((subject) => (
      <React.Fragment key={subject.id}>
        <span>›</span>
        <button type="button" onClick={() => onChooseSubject(subject.id)}>
          {subject.title}
        </button>
      </React.Fragment>
    ))}
  </nav>
);
